import { boot } from 'quasar/wrappers';
import { existUnSavedOrderChanges, openItem, markItem, getAllValues, renderTableitems, deepEqual,isDeepEqual,sClone,lodashClonedeep,isJSONequal,deepClone, getPosition, debounce} from 'src/js/global.js';

export default boot(({ app }) => {
    app.config.globalProperties.$global = {
      renderTableitems,
      deepClone,
      lodashClonedeep,
      debounce,
      getPosition,
      deepEqual,
      sClone,
      isDeepEqual,
      isJSONequal,
      markItem,
      getAllValues,
      openItem,
      existUnSavedOrderChanges
    }
});